<div class="aside">
    <h2 class="title">
        Recent posts
    </h2>
    <app-post-list></app-post-list>
</div>